import { inject, Injectable } from '@angular/core';
import { ENVIRONMENT } from '../app-config';
import { ExternalUrls } from '@/environments/environment.interface';

@Injectable({ providedIn: 'root' })
export class ExternalUrlsService implements ExternalUrls {

    private readonly environment = inject(ENVIRONMENT);
    private readonly externalUrls = this.environment.externalUrls;

    get com(): string {
        return this.externalUrls?.com || '';
    }

    get trends(): string {
        return this.externalUrls?.trends || '';
    }

    get activeEvents(): string {
        return this.externalUrls?.activeEvents || '';
    }
}
